<template>
  <b-container class="site-detail__reportsettings contentcontainer">
    <b-row class="contentcontainer__head">
      <b-col>
        <h2>{{$t('config.schedule')}}</h2>
      </b-col>
      <b-col>
        <div class="actions">
          <button class="btn btn--success" v-on:click="save">
            <span class="icon">
                <font-awesome-icon class="icon" :icon="['fal','save']"></font-awesome-icon>
            </span>
            {{$t('config.save')}}
          </button>
        </div>
      </b-col>
    </b-row>
    <hr/>
    <b-row>
      <b-col>
        <div class="info" v-if="siteDetail.data.backup_tools_installed && siteDetail.data.can_start_backup">
          <div class="table-responsive-lg">
            <table class="table table--overview">
              <thead>
                <tr>
                  <th>
                    {{$t('config.day')}}
                  </th>
                  <th>
                    {{$t('config.createbackup')}}
                  </th>
                  <th>
                    {{$t('config.testbackup')}}
                  </th>
                  <th>
                    {{$t('config.backupprofile')}}
                  </th>
                  <th class="text-center">
                    {{$t('config.time')}}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{$t('config.monday')}}
                  </td>
                  <td v-bind:data-th="$t('config.createbackup')">
                    <b-form-checkbox
                            v-on:change="toggleBackup"
                            v-model="backup"
                            value="1"
                    ></b-form-checkbox>
                  </td>
                  <td v-bind:data-th="$t('config.testbackup')">
                    <b-form-checkbox
                            v-on:change="toggleTest"
                            v-model="test"
                            value="1"
                    ></b-form-checkbox>
                  </td>
                  <td>
                    <b-form-select
                      v-bind:options="profiles"
                      class="profile-select"
                      v-bind:disabled="useDefaultBackupProfile"
                      v-model="dayProfile.monday"
                    >
                    </b-form-select>
                  </td>
                  <td class="text-center" v-bind:data-th="$t('config.time')">
                    <b-input-group class="time-select">
                      <b-form-select
                              v-bind:options="optionsHour"
                              class="hour-select"
                              v-bind:disabled="useDefaultBackupTime"
                              v-model="startTime.monday.h"
                      >
                      </b-form-select>
                      <b-form-select
                              v-bind:options="optionsMinute"
                              class="minute-select"
                              v-bind:disabled="useDefaultBackupTime"
                              v-model="startTime.monday.m"
                      >
                      </b-form-select>
                    </b-input-group>
                  </td>
                </tr>
                <tr>
                  <td>
                    {{$t('config.tuesday')}}
                  </td>
                  <td class="text-center" v-bind:data-th="$t('config.createbackup')">
                    <b-form-checkbox
                            v-on:change="toggleBackup"
                            v-model="backup"
                            value="2"
                    ></b-form-checkbox>
                  </td>
                  <td class="text-center" v-bind:data-th="$t('config.testbackup')">
                    <b-form-checkbox
                            v-on:change="toggleTest"
                            v-model="test"
                            value="2"
                    ></b-form-checkbox>
                  </td>
                  <td>
                    <b-form-select
                      v-bind:options="profiles"
                      class="profile-select"
                      v-bind:disabled="useDefaultBackupProfile"
                      v-model="dayProfile.tuesday"
                    >
                    </b-form-select>
                  </td>
                  <td class="text-center" v-bind:data-th="$t('config.time')">
                    <b-input-group class="time-select">
                      <b-form-select
                              v-bind:options="optionsHour"
                              class="hour-select"
                              v-bind:disabled="useDefaultBackupTime"
                              v-model="startTime.tuesday.h"
                      >
                      </b-form-select>
                      <b-form-select
                              v-bind:options="optionsMinute"
                              class="minute-select"
                              v-bind:disabled="useDefaultBackupTime"
                              v-model="startTime.tuesday.m"
                      >
                      </b-form-select>
                    </b-input-group>
                  </td>
                </tr>
                <tr>
                  <td>
                    {{$t('config.wednesday')}}
                  </td>
                  <td class="text-center" v-bind:data-th="$t('config.createbackup')">
                    <b-form-checkbox
                            v-on:change="toggleBackup"
                            v-model="backup"
                            value="3"
                    ></b-form-checkbox>
                  </td>
                  <td class="text-center" v-bind:data-th="$t('config.testbackup')">
                    <b-form-checkbox
                            v-on:change="toggleTest"
                            v-model="test"
                            value="3"
                    ></b-form-checkbox>
                  </td>
                  <td>
                    <b-form-select
                      v-bind:options="profiles"
                      class="profile-select"
                      v-bind:disabled="useDefaultBackupProfile"
                      v-model="dayProfile.wednesday"
                    >
                    </b-form-select>
                  </td>

                  <td class="text-center" v-bind:data-th="$t('config.time')">
                    <b-input-group class="time-select">
                      <b-form-select
                              v-bind:options="optionsHour"
                              class="hour-select"
                              v-bind:disabled="useDefaultBackupTime"
                              v-model="startTime.wednesday.h"
                      >
                      </b-form-select>
                      <b-form-select
                              v-bind:options="optionsMinute"
                              class="minute-select"
                              v-bind:disabled="useDefaultBackupTime"
                              v-model="startTime.wednesday.m"
                      >
                      </b-form-select>
                    </b-input-group>
                  </td>
                </tr>
                <tr>
                  <td>
                    {{$t('config.thursday')}}
                  </td>
                  <td class="text-center" v-bind:data-th="$t('config.createbackup')">
                    <b-form-checkbox
                            v-on:change="toggleBackup"
                            v-model="backup"
                            value="4"
                    ></b-form-checkbox>
                  </td>
                  <td class="text-center" v-bind:data-th="$t('config.testbackup')">
                    <b-form-checkbox
                            v-on:change="toggleTest"
                            v-model="test"
                            value="4"
                    ></b-form-checkbox>
                  </td>
                  <td>
                    <b-form-select
                      v-bind:options="profiles"
                      class="profile-select"
                      v-bind:disabled="useDefaultBackupProfile"
                      v-model="dayProfile.thursday"
                    >
                    </b-form-select>
                  </td>
                  <td class="text-center" v-bind:data-th="$t('config.time')">
                    <b-input-group class="time-select">
                      <b-form-select
                              v-bind:options="optionsHour"
                              class="hour-select"
                              v-bind:disabled="useDefaultBackupTime"
                              v-model="startTime.thursday.h"
                      >
                      </b-form-select>
                      <b-form-select
                              v-bind:options="optionsMinute"
                              class="minute-select"
                              v-bind:disabled="useDefaultBackupTime"
                              v-model="startTime.thursday.m"
                      >
                      </b-form-select>
                    </b-input-group>
                  </td>
                </tr>
                <tr>
                  <td>
                    {{$t('config.friday')}}
                  </td>
                  <td class="text-center" v-bind:data-th="$t('config.createbackup')">
                    <b-form-checkbox
                            v-on:change="toggleBackup"
                            v-model="backup"
                            value="5"
                    ></b-form-checkbox>
                  </td>
                  <td class="text-center" v-bind:data-th="$t('config.testbackup')">
                    <b-form-checkbox
                            v-on:change="toggleTest"
                            v-model="test"
                            value="5"
                    ></b-form-checkbox>
                  </td>
                  <td>
                    <b-form-select
                      v-bind:options="profiles"
                      class="profile-select"
                      v-bind:disabled="useDefaultBackupProfile"
                      v-model="dayProfile.friday"
                    >
                    </b-form-select>
                  </td>
                  <td class="text-center" v-bind:data-th="$t('config.time')">
                    <b-input-group class="time-select">
                      <b-form-select
                              v-bind:options="optionsHour"
                              class="hour-select"
                              v-bind:disabled="useDefaultBackupTime"
                              v-model="startTime.friday.h"
                      >
                      </b-form-select>
                      <b-form-select
                              v-bind:options="optionsMinute"
                              class="minute-select"
                              v-bind:disabled="useDefaultBackupTime"
                              v-model="startTime.friday.m"
                      >
                      </b-form-select>
                    </b-input-group>
                  </td>
                </tr>
                <tr>
                  <td>
                    {{$t('config.saturday')}}
                  </td>
                  <td class="text-center" v-bind:data-th="$t('config.createbackup')">
                    <b-form-checkbox
                            v-on:change="toggleBackup"
                            v-model="backup"
                            value="6"
                    ></b-form-checkbox>
                  </td>
                  <td class="text-center" v-bind:data-th="$t('config.testbackup')">
                    <b-form-checkbox
                            v-on:change="toggleTest"
                            v-model="test"
                            value="6"
                    ></b-form-checkbox>
                  </td>
                  <td>
                    <b-form-select
                      v-bind:options="profiles"
                      class="profile-select"
                      v-bind:disabled="useDefaultBackupProfile"
                      v-model="dayProfile.saturday"
                    >
                    </b-form-select>
                  </td>

                  <td class="text-center" v-bind:data-th="$t('config.time')">
                    <b-input-group class="time-select">
                      <b-form-select
                              v-bind:options="optionsHour"
                              class="hour-select"
                              v-bind:disabled="useDefaultBackupTime"
                              v-model="startTime.saturday.h"
                      >
                      </b-form-select>
                      <b-form-select
                              v-bind:options="optionsMinute"
                              class="minute-select"
                              v-bind:disabled="useDefaultBackupTime"
                              v-model="startTime.saturday.m"
                      >
                      </b-form-select>
                    </b-input-group>
                  </td>
                </tr>
                <tr>
                  <td>
                    {{$t('config.sunday')}}
                  </td>
                  <td class="text-center" v-bind:data-th="$t('config.createbackup')">
                    <b-form-checkbox
                            v-on:change="toggleBackup"
                            v-model="backup"
                            value="7"
                    ></b-form-checkbox>
                  </td>
                  <td class="text-center" v-bind:data-th="$t('config.testbackup')">
                    <b-form-checkbox
                            v-on:change="toggleTest"
                            v-model="test"
                            value="7"
                    ></b-form-checkbox>
                  </td>
                  <td>
                    <b-form-select
                      v-bind:options="profiles"
                      class="profile-select"
                      v-bind:disabled="useDefaultBackupProfile"
                      v-model="dayProfile.sunday"
                    >
                    </b-form-select>
                  </td>
                  <td class="text-center" v-bind:data-th="$t('config.time')">
                    <b-input-group class="time-select">
                      <b-form-select
                              v-bind:options="optionsHour"
                              class="hour-select"
                              v-bind:disabled="useDefaultBackupTime"
                              v-model="startTime.sunday.h"
                      >
                      </b-form-select>
                      <b-form-select
                              v-bind:options="optionsMinute"
                              class="minute-select"
                              v-bind:disabled="useDefaultBackupTime"
                              v-model="startTime.sunday.m"
                      >
                      </b-form-select>
                    </b-input-group>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <hr/>
          <div class="info" v-if="siteDetail.data.backup_tools_installed && siteDetail.data.can_start_backup">
            <b-row>
              <b-col lg="6">
                <b-form-group
                  id="profile-group"
                  :label="$t('config.standardprofile')"
                  label-for="profile"
                >
                  <b-form-select
                    id="profile"
                    v-bind:options="profiles"
                    v-model="dayProfile.default"
                  >
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group>
                  <b-form-checkbox
                    v-model="useDefaultBackupProfile"
                  >
                    {{$t('config.alwaysuseprofile')}}
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="4">
                <b-form-group
                  :label="$t('config.backuptime')"
                >
                  <b-row align-v="center">
                    <b-col lg="5">
                      <b-form-select
                        id="default-h"
                        v-bind:options="optionsHour"
                        v-model="startTime.default.h"
                      >
                      </b-form-select>
                    </b-col>
                    <b-col lg="5">
                      <b-form-select
                        id="default-m"
                        v-bind:options="optionsMinute"
                        v-model="startTime.default.m"
                      >
                      </b-form-select>
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group>
                  <b-form-checkbox
                    v-model="useDefaultBackupTime"
                  >
                    {{$t('config.alwaysuse')}}
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <div class="info" v-else>
            <div class="contentcontainer contentcontainer--danger">
              <b-container>
                <b-row align-v="center">
                  <b-col sm="3" lg="2" xl="1">
                    <img src="/images/icon/sitedetail/dashboard/general-danger.svg"/>
                  </b-col>
                  <b-col sm="9" lg="10" xl="11">
                    <p v-html="$t('config.nobackuptool')"></p>
                  </b-col>
                </b-row>
              </b-container>
            </div>
          </div>
      </b-col>
    </b-row>
    <hr/>
    <b-row align-h="end" class="contentcontainer__footer">
      <b-col cols="auto">
        <div class="actions">
          <button class="btn btn--success" v-on:click="save">
            <span class="icon">
                <font-awesome-icon class="icon" :icon="['fal','save']"></font-awesome-icon>
            </span>
            {{$t('config.save')}}
          </button>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import { mapState, mapActions, mapMutations } from 'vuex'

import mixins from '../../mixins'

export default {

  name: 'SiteDetailSchedule',

  mixins: [mixins],

  computed: {

    ...mapState('site', [
      'siteDetail'
    ])
  },

  data () {
    return {
      backup: [],
      test: [],
      profiles: [],
      cronDow: [
        'sunday',
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
        'sunday'
      ],
      useDefaultBackupTime: true,
      useDefaultBackupProfile: true,
      sendReport: false,
      reportEmail: '',
      reportContactPerson: '',
      currentSavedValues: {},
      optionsHour: [
        { value: 0, text: '00' },
        { value: 1, text: '01' },
        { value: 2, text: '02' },
        { value: 3, text: '03' },
        { value: 4, text: '04' },
        { value: 5, text: '05' },
        { value: 6, text: '06' },
        { value: 7, text: '07' },
        { value: 8, text: '08' },
        { value: 9, text: '09' },
        { value: 10, text: '10' },
        { value: 11, text: '11' },
        { value: 12, text: '12' },
        { value: 13, text: '13' },
        { value: 14, text: '14' },
        { value: 15, text: '15' },
        { value: 16, text: '16' },
        { value: 17, text: '17' },
        { value: 18, text: '18' },
        { value: 19, text: '19' },
        { value: 20, text: '20' },
        { value: 21, text: '21' },
        { value: 22, text: '22' },
        { value: 23, text: '23' }
      ],
      optionsMinute: [
        { value: 0, text: '00' },
        { value: 15, text: '15' },
        { value: 30, text: '30' },
        { value: 45, text: '45' }
      ],
      startTime: {
        default: {
          h: 5,
          m: 0
        },
        monday: {
          h: 5,
          m: 0
        },
        tuesday: {
          h: 5,
          m: 0
        },
        wednesday: {
          h: 5,
          m: 0
        },
        thursday: {
          h: 5,
          m: 0
        },
        friday: {
          h: 5,
          m: 0
        },
        saturday: {
          h: 5,
          m: 0
        },
        sunday: {
          h: 5,
          m: 0
        }
      },
      dayProfile: {
        default: 0,
        monday: 0,
        tuesday: 0,
        wednesday: 0,
        thursday: 0,
        friday: 0,
        saturday: 0,
        sunday: 0
      }
    }
  },

  watch: {

    'siteDetail': {
      handler () {
        this.preparePage()
      },
      deep: true
    },

    'startTime': {
      handler () {
        this.copyDefaultTime()
      },
      deep: true
    },

    'dayProfile': {
      handler () {
        this.copyDefaultProfile()
      },
      deep: true
    },

    'useDefaultBackupTime': function () {
      this.copyDefaultTime()
    },

    'useDefaultBackupProfile': function () {
      this.copyDefaultProfile()
    }
  },

  methods: {

    ...mapMutations('site', [
      'closeSiteDetailPageConfiguration'
    ]),

    ...mapActions('site', [
      'saveSiteConfiguration',
      'saveSitePlan'
    ]),

    close () {
      this.closeSiteDetailPageConfiguration()
    },

    copyDefaultTime () {
      if (this.useDefaultBackupTime) {
        this.startTime.monday.h = this.startTime.default.h
        this.startTime.monday.m = this.startTime.default.m
        this.startTime.tuesday.h = this.startTime.default.h
        this.startTime.tuesday.m = this.startTime.default.m
        this.startTime.wednesday.h = this.startTime.default.h
        this.startTime.wednesday.m = this.startTime.default.m
        this.startTime.thursday.h = this.startTime.default.h
        this.startTime.thursday.m = this.startTime.default.m
        this.startTime.friday.h = this.startTime.default.h
        this.startTime.friday.m = this.startTime.default.m
        this.startTime.saturday.h = this.startTime.default.h
        this.startTime.saturday.m = this.startTime.default.m
        this.startTime.sunday.h = this.startTime.default.h
        this.startTime.sunday.m = this.startTime.default.m
      }
    },

    copyDefaultProfile () {
      if (this.useDefaultBackupProfile) {
        this.dayProfile.monday = this.dayProfile.default
        this.dayProfile.tuesday = this.dayProfile.default
        this.dayProfile.wednesday = this.dayProfile.default
        this.dayProfile.thursday = this.dayProfile.default
        this.dayProfile.friday = this.dayProfile.default
        this.dayProfile.saturday = this.dayProfile.default
        this.dayProfile.sunday = this.dayProfile.default
      }
    },

    hasConfigurationChanged () {
      return (this.currentSavedValues['default_backup_time'] === -1) ||
            (
              String(this.currentSavedValues['default_backup_time']).substring(0, 2) !==
                String(this.startTime.default.h).padStart(2, '0')
            ) ||
            (
              String(this.currentSavedValues['default_backup_time']).substring(3) !==
                String(this.startTime.default.m).padStart(2, '0')
            ) ||
            (this.currentSavedValues['default_backup_profile'] !== this.dayProfile.default) ||
            (this.currentSavedValues['use_default_backup_time'] !== this.useDefaultBackupTime) ||
            (this.currentSavedValues['use_default_backup_profile'] !== this.useDefaultBackupProfile)
    },

    hasPlanChanged () {
      return true
    },

    preparePage () {
      // reset variables
      this.profiles = []
      this.currentSavedValues = {}
      this.backup = []
      this.test = []
      this.dayProfile.default = 0
      this.startTime.default.h = 5
      this.startTime.default.m = 0

      // get the profiles configured for the site
      let profiles = this.getProfiles(this.siteDetail.data.backup_tools)

      if (profiles.length > 0) {
        profiles.forEach((e) => {
          this.profiles.push(
            {
              value: e.id,
              text: e.description
            }
          )
        })
      }

      // check for initial state
      if (this.siteDetail.data.configuration === null) {
        // no configuration was done before, use defaults
        if (profiles.length > 0) {
          this.dayProfile.default = profiles[0].id
        }
      } else {
        // default backup profile
        let defaultBackupProfile = this.getConfigValue(
          this.siteDetail.data.configuration,
          'default_backup_profile',
          -1
        )

        this.currentSavedValues['default_backup_profile'] = defaultBackupProfile

        if (defaultBackupProfile === -1) {
          // not set yet
          defaultBackupProfile = profiles[0].id
        }

        this.dayProfile.default = defaultBackupProfile

        this.copyDefaultProfile()

        // use default backup profile
        let useDefaultBackupProfile = this.getConfigValue(
          this.siteDetail.data.configuration,
          'use_default_backup_profile',
          -1
        )

        this.currentSavedValues['use_default_backup_profile'] = useDefaultBackupProfile

        if (useDefaultBackupProfile === -1) {
          // not set yet
          useDefaultBackupProfile = true
        }

        this.useDefaultBackupProfile = useDefaultBackupProfile

        // use default backup time
        let useDefaultBackupTime = this.getConfigValue(
          this.siteDetail.data.configuration,
          'use_default_backup_time',
          -1
        )

        this.currentSavedValues['use_default_backup_time'] = useDefaultBackupTime

        if (useDefaultBackupTime === -1) {
          // not set yet
          useDefaultBackupTime = true
        }

        this.useDefaultBackupTime = useDefaultBackupTime

        // default backup time
        let defaultBackupTime = this.getConfigValue(
          this.siteDetail.data.configuration,
          'default_backup_time',
          -1
        )

        this.currentSavedValues['default_backup_time'] = defaultBackupTime

        if (defaultBackupTime !== -1) {
          let h = defaultBackupTime.substring(0, 2)
          if (h.startsWith('0')) {
            h = defaultBackupTime.substring(1, 2)
          }

          let m = defaultBackupTime.substring(3)
          if (m.startsWith('0')) {
            m = defaultBackupTime.substring(4)
          }

          this.startTime.default.h = h
          this.startTime.default.m = m
        }
      }

      // Check plan
      let plan = this.siteDetail.data.plans
      let dayname = 'monday'

      if (plan.length > 0) {
        plan.forEach((e) => {
          if (e.action === 'backupandtest') {
            this.test.push(e.dow)
            this.backup.push(e.dow)
          } else {
            if (e.action === 'backup') {
              this.backup.push(e.dow)
            }
          }
          dayname = this.cronDow[e.dow]
          this.dayProfile[dayname] = e.profile_id
          this.startTime[dayname].h = e.hour
          this.startTime[dayname].m = e.minute
        })
      }
    },

    save () {
      if (this.hasConfigurationChanged()) {
        let startTime = String(this.startTime.default.h).padStart(2, '0') +
                                        ':' +
                                        String(this.startTime.default.m).padStart(2, '0')

        let payload = {
          id: this.siteDetail.id,
          configuration: {
            'default_backup_profile': this.dayProfile.default,
            'use_default_backup_profile': this.useDefaultBackupProfile,
            'use_default_backup_time': this.useDefaultBackupTime,
            'default_backup_time': startTime
          }
        }

        this.saveSiteConfiguration(payload)
      }

      if (this.hasPlanChanged()) {
        let plan = {}
        let test = false
        let backup = false
        let dayname = 'monday'
        let items = []

        for (let i = 1; i < 8; i++) {
          plan = {}
          test = this.test.includes(String(i))
          backup = this.backup.includes(String(i))
          dayname = this.cronDow[i]

          if (!test && !backup) {
            // nothing selected -> done
            continue
          }

          plan.type = test ? 'backupandtest' : 'backup'
          plan.dow = i
          plan.profile = this.dayProfile[dayname]

          if (this.useDefaultBackupTime) {
            plan.hour = this.startTime.default.h
            plan.minute = this.startTime.default.m
          } else {
            plan.hour = this.startTime[dayname].h
            plan.minute = this.startTime[dayname].m
          }

          items.push(plan)
        }

        let payload = {
          id: this.siteDetail.id,
          plan: items
        }

        this.saveSitePlan(payload)
      }
    },

    toggleBackup (e) {
      if (e === null) {
        this.$nextTick(() => {
          let toRemove = []

          this.test.forEach((t, index) => {
            if (!this.backup.includes(t)) {
              toRemove.push(index)
            }
          })
          toRemove.forEach((r) => {
            this.test.splice(r, 1)
          })
        })
      }
    },

    toggleTest (e) {
      if (e !== null) {
        if (!this.backup.includes(String(e))) {
          this.backup.push(e)
        }
      }
    }

  }
}
</script>
